import CEOMan from 'assets/characters/avatar/CEO-Man.svg'
import CEOWoman from 'assets/characters/avatar/CEO-Woman.svg'
import CFOMan from 'assets/characters/avatar/CFO-Man.svg'
import CFOWoman from 'assets/characters/avatar/CFO-Woman.svg'
import CMOMan from 'assets/characters/avatar/CMO-Man.svg'
import CMOWoman from 'assets/characters/avatar/CMO-Woman.svg'
import { MARKET_ROUND_TEAM_PALETTE } from 'constants/marketRoundTeamColors'

export const TEAM_SLOTS = [1, 2, 3, 4, 5]
export const MAX_PLAYERS_PER_TEAM = 5

/** Max length for team name and player alias when editing in the Lobby */
export const LOBBY_NAME_MAX_LENGTH = 12

/**
 * Caps lobby name input at max length when typing/pasting, but allows shortening
 * values longer than max (e.g. legacy server data) until the user deletes enough.
 */
export const clampLobbyNameInput = (previous, next, max = LOBBY_NAME_MAX_LENGTH) => {
  if (next.length <= max) return next
  if (next.length < previous.length) return next
  return next.slice(0, max)
}

export const AVATAR_NAMES = ['avatar_1', 'avatar_2', 'avatar_3', 'avatar_4', 'avatar_5', 'avatar_6']
export const AVATAR_IMAGES = {
  avatar_1: CEOMan,
  avatar_2: CEOWoman,
  avatar_3: CFOMan,
  avatar_4: CFOWoman,
  avatar_5: CMOMan,
  avatar_6: CMOWoman
}
export const DEFAULT_AVATAR = 'avatar_1'

export const getAvatarSrc = (avatarKey) => AVATAR_IMAGES[avatarKey] || AVATAR_IMAGES[DEFAULT_AVATAR]

export const PLAYER_ROLES = [
  { value: 'ceo', label: 'CEO' },
  { value: 'cto', label: 'CTO' },
  { value: 'coo', label: 'COO' },
  { value: 'cfo', label: 'CFO' },
  { value: 'cmo', label: 'CMO' }
]

export const LOBBY_TEAM_COLORS = MARKET_ROUND_TEAM_PALETTE

// Matches playlearning-admin Team::DECISION_STRATEGY_AI_CONFIG / lets-roll-api DECISION_STRATEGY_NAME_MAP
export const AI_STRATEGY_OPTIONS = [
  { value: 'Differentiation', label: 'Differentiation' },
  { value: 'Focus', label: 'Focus' },
  { value: 'Cost Leadership', label: 'Cost Leadership' }
]
